import user from "../views/pages/app/user";

export function getMvpUserType(userFromRedux) {
  const fromState = userFromRedux?.type || userFromRedux?.mvpUserType || userFromRedux?.role;
  if (fromState) return fromState;
  try {
    const raw = localStorage.getItem('ced:user-info');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.type || parsed?.mvpUserType || parsed?.role || null;
  } catch (e) {
    return null;
  }
}

export function isMvpUserGuide(userFromRedux) {
  return getMvpUserType(userFromRedux) === 'guide';
}

export function isMvpUserExplorer(userFromRedux) {
  const type = getMvpUserType(userFromRedux);
  return type === 'senior' || type === 'explorer' || type === 'both';
}

export default {
    getHeaderForMvp: () => {
        let userInfo = localStorage.getItem('ced:user-info')
        let token = null
        if (userInfo) {
            const user = JSON.parse(userInfo)
            token = user.accessToken
        }
        return {'authorization': token}
    }
}